import {useEffect} from 'react'

import Divider from '@mui/material/Divider'
import Stack from '@mui/material/Stack'
import TuneIcon from '@mui/icons-material/Tune'
import Typography from '@mui/material/Typography'

import FeatureFlags from './FeatureFlags'
import Loader from '../../shared/Loader'
import OtherSettings from './OtherSettings'

import {connect} from '../../../state/hooks/tools'
import {isEmpty} from '../../../lib/tools'
import {readEndpoint} from '../../../lib/asyncMethods'
import {APPLICATIONS, SETTINGS} from '../../../state/actionTypes'

import './settingsController.scss'

/**
 * Every settings row an admin is handed, split into the flags that switch behaviour on and the rows
 * that carry a value.
 *
 * Applications come along because a row names its owner by id alone, and an application is the only
 * owner a settings row currently has that this page cannot name from what it already holds. Nothing
 * waits on them: an unnamed owner shows as the id it is until they arrive.
 */
const SettingsController = props => {
  useEffect(() => {
    if (isEmpty(props.settings))
      props.readSettings('settings')

    if (isEmpty(props.applications))
      props.readApplications('metadata/applications')
  }, [])

  return (
    <Loader loading={props.loading && isEmpty(props.settings)}>
      <Stack className='settings-controller'>
        <Stack className='label' direction='row'>
          <TuneIcon fontSize='large' />
          <Typography variant='h5'>Settings</Typography>
        </Stack>
        <Divider />
        <FeatureFlags />
        <OtherSettings />
      </Stack>
    </Loader>
  )
}

const mapStateToProps = ({metadata}) => ({...metadata})

const actionCreators = ({metadata}) => ({
  readSettings: readEndpoint(metadata, SETTINGS),
  readApplications: readEndpoint(metadata, APPLICATIONS)
})

export default connect(mapStateToProps, actionCreators)(SettingsController)
